import { render, staticRenderFns } from "./Web_manager.vue?vue&type=template&id=4a033db6&scoped=true&"
import script from "./Web_manager.vue?vue&type=script&lang=js&"
export * from "./Web_manager.vue?vue&type=script&lang=js&"
import style0 from "./Web_manager.vue?vue&type=style&index=0&id=4a033db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a033db6",
  null
  
)

export default component.exports